import { useEffect, useState } from "react";

import { GoogleButton } from "react-google-button";
import { UserAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

const Signin = () => {
	const [message, setMessage] = useState("Please login with a known email address:");

	const { googleSignIn, user, logOut } = UserAuth();
	const navigate = useNavigate();

	const handleGoogleSignIn = async () => {
		try {
			const user = await googleSignIn();
			navigate("/");
			// const allowedDomains = ["satori-ai.com"]; // Add your allowed domains here
			// const emailDomain = user.email.split("@")[1];

			// if (allowedDomains.includes(emailDomain)) {
			// 	navigate("/");
			// } else {
			// 	console.log("Invalid email domain");
			// 	setMessage(`Invalid email: ${user.email}`);
			// 	await logOut(); // Sign out the user
			// }
		} catch (error) {
			console.log(error);
		}
	};

	useEffect(() => {
		if ((user !== null) & (message === "")) {
			navigate("/");
		}
	}, [user]);

	return (
		<div>
			<h1 className="text-center text-3xl font-bold py-8">Sign in</h1>
			<div className="max-w-[240px] m-auto py-4">
				<GoogleButton onClick={handleGoogleSignIn} />
				<div>{message}</div>
			</div>
		</div>
	);
};

export default Signin;
